import React, { useState } from "react";
import "./form.css";

function encode(data) {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
}

function Form() {
  const [state, setState] = useState({});
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": "contact", ...state }),
    })
      .then(() => setSuccess(true))
      .catch((error) => alert(error));
  };

  if (success) {
    return <p className="message-sent">Thanks! Your message has been sent.</p>;
  }

  return (
    <form name="contact" method="POST" onSubmit={handleSubmit} className="contact-form" netlify>
      <input type="hidden" name="form-name" value="contact" />
      <input
        type="text"
        name="name"
        placeholder="Your Name"
        onChange={handleChange}
        required
      />
      <input
        type="email"
        name="email"
        placeholder="Email"
        onChange={handleChange}
        required
      />
      <input
        type="text"
        name="phone"
        placeholder="Phone (optional)"
        onChange={handleChange}
      />
      <textarea
        name="message"
        placeholder="Your Message"
        onChange={handleChange}
        required
      />
      <button type="submit">Send Message</button>
    </form>
  );
}

export default Form;
